import { render, staticRenderFns } from "./dialogPreviewInfo.vue?vue&type=template&id=05154212&scoped=true&"
import script from "./dialogPreviewInfo.vue?vue&type=script&lang=js&"
export * from "./dialogPreviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogPreviewInfo.vue?vue&type=style&index=0&id=05154212&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05154212",
  null
  
)

export default component.exports